import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import CreatePostFigure from "../../../assets/imgs/create-new-post.png";

import HowItWorksStepper from "./HowItWorksStepper";

const HowItWorks = ({ handleNext }: { handleNext: () => void }) => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "55px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "28px" }}>
        <img src={CreatePostFigure} alt="Create Post Figure" style={{ width: "83.581px", height: "100px" }} />
        <Typography
          variant="h3"
          sx={{
            color: "#1D1D1D",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "32px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "normal",
          }}
        >
          {t("createNewPost")}
        </Typography>
        <Button variant="primary-sm" onClick={handleNext}>
          {t("createPost")}
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "69px",
          borderRadius: "16px",
          background: "#F5F6F5",
          padding: "32px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Typography
            component="h6"
            sx={{
              color: "#1D1D1D",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "32px",
              fontStyle: "normal",
              fontWeight: 800,
              lineHeight: "normal",
            }}
          >
            {t("howItWorks")}
          </Typography>
          <Typography
            component="p"
            sx={{
              color: "var(--Dark---600, #707070)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
            }}
          >
            {t("shareYourMoments")}
          </Typography>
        </Box>
        <HowItWorksStepper />
      </Box>
    </Box>
  );
};

export default HowItWorks;
